import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { components, copy } from '@peachjar/components';
import { css } from 'react-emotion';

import WhiteSpaceSvgWrapper from '../../../../../components/WhiteSpaceSvgWrapper';
import DeskWoman from '../../../../../components/DeskWoman.svg';
import UserRegistrationForm from './UserRegistrationForm';
import TempRightActionHelper from '../../../components/TempRightActionHelper';

const { FullSpread, ContentColumn, WhitespaceColumn } = components;
const { quotes } = copy;

class UserRegistrationContainer extends Component<Props> {
  render() {
    const {
      previousPage,
      nextPage,
      history,
      hasPaidAndSigned,
      id: registrationId,
    } = this.props;

    return (
      <FullSpread>
        <ContentColumn
          onClick={() => history.push('/onboarding')}
          rightAction={<TempRightActionHelper />}
        >
          <UserRegistrationForm
            nextPage={nextPage}
            hasPaidAndSigned={hasPaidAndSigned}
            registrationId={registrationId}
          />
        </ContentColumn>
        <WhitespaceColumn>
          <WhiteSpaceSvgWrapper
            svg={<DeskWoman />}
            quote={quotes.voelpel_savesTeacherTime}
          />
        </WhitespaceColumn>
      </FullSpread>
    );
  }
}

export default withRouter(UserRegistrationContainer);



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/UserRegistration/containers/UserRegistrationContainer.jsx